import React from 'react'
import { Box } from '@chakra-ui/react'
import ReconciliationView from './components/ReconciliationView'

export default function ReconciliationIndex() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <ReconciliationView />
    </Box>
  )
}
